import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './BestPhysioRehabManufacturer.css';

const BestPhysioRehabManufacturer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.primerehabindustries.in/#organization",
          "name": "Prime Rehab Industries",
          "url": "https://www.primerehabindustries.in",
          "logo": "https://www.primerehabindustries.in/logo.png",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.primerehabindustries.in/#localbusiness",
          "name": "Prime Rehab Industries",
          "parentOrganization": { "@id": "https://www.primerehabindustries.in/#organization" },
          "url": "https://www.primerehabindustries.in",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          },
          "areaServed": "Tamil Nadu, India",
          "priceRange": "Contact for pricing"
        },
        {
          "@type": "Product",
          "name": "Best Physiotherapy and Rehabilitation Equipment Range",
          "description": "Prime Rehab Industries manufactures over 100 physiotherapy and rehabilitation equipment models including treatment tables, tilt tables, traction tables, chiropractic equipment, and unweighing systems for clinics and hospitals across India.",
          "brand": { "@id": "https://www.primerehabindustries.in/#organization" },
          "manufacturer": { "@id": "https://www.primerehabindustries.in/#organization" },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "145",
            "bestRating": "5"
          },
          "review": [
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Kavitha Nair" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "datePublished": "2025-04-10",
              "reviewBody": "We sourced our entire outpatient physiotherapy setup from Prime Rehab high-low tables, a tilt table, and a traction unit. Everything arrived on time and is holding up well under busy clinic conditions. The quality is consistently good across all three product types."
            },
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Dr. Senthil Kumar" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "datePublished": "2025-08-05",
              "reviewBody": "What I appreciate most about Prime Rehab is that they manufacture both physiotherapy and neurological rehabilitation equipment under one roof. For a centre like ours that handles both outpatient physio and long-term rehab, it simplifies procurement significantly."
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is the difference between physiotherapy equipment and rehabilitation equipment?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Physiotherapy equipment typically refers to tools used for hands-on treatment — such as treatment tables, traction tables, and tilt tables used during active therapy sessions. Rehabilitation equipment covers a broader range of devices that support recovery over time, including unweighing systems for gait training, Bobath tables for neurodevelopmental therapy, and ADL training setups. Prime Rehab Industries manufactures both categories under one roof."
              }
            },
            {
              "@type": "Question",
              "name": "How do I choose the right treatment table for my clinic's therapy specialty?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The right treatment table depends on your therapy protocols. For general outpatient physiotherapy, a motorised high-low table gives you the height flexibility to work safely with different patients. Neurological therapy centres benefit from a wide-surface Bobath table. Spinal and orthopaedic clinics typically require a traction table or tilt table. Prime Rehab's team can advise on the best fit for your practice — contact us at +91 99943 51947."
              }
            },
            {
              "@type": "Question",
              "name": "Does Prime Rehab Industries manufacture equipment for both physiotherapy and neurological rehabilitation?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries manufactures equipment across physiotherapy, chiropractic, orthopaedic, and neurological rehabilitation specialties. This includes high-low treatment tables, traction and tilt tables, Bobath tables, unweighing systems for gait training, and chiropractic drop tables — all available from a single manufacturer."
              }
            },
            {
              "@type": "Question",
              "name": "How long does it take to receive equipment after placing an order with Prime Rehab?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Lead times vary depending on the product and order volume. Standard models from Prime Rehab's core range are typically available faster than custom configurations. Contact our team at primerehaboffl@gmail.com or call +91 99943 51947 for a specific delivery estimate based on your requirements."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.primerehabindustries.in"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": "https://www.primerehabindustries.in/blog"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Best Physiotherapy Equipment & Rehab Equipment Manufacturer",
              "item": "https://www.primerehabindustries.in/blog/physiotherapy-equipment-rehab-equipment-manufacturer"
            }
          ]
        }
      ]
    };

    document.title = "Physiotherapy & Rehab Equipment Manufacturer | Prime Rehab";

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Looking for a physiotherapy and rehab equipment manufacturer? Prime Rehab Industries offers 100+ models, trusted by 500+ clinics with 1,000+ installations.";

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://www.primerehabindustries.in/blog/physiotherapy-equipment-rehab-equipment-manufacturer";

    let script = document.querySelector('#blog-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'blog-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.innerHTML = JSON.stringify(schema);

    return () => {};
  }, []);

  return (
    <div className="manu-layout">
      <Navbar />

      {/* Hero Section */}
      <section className="manu-hero">
        <div className="manu-container">
          <div className="manu-hero-grid">
            <div className="manu-hero-content">
              <span className="category-tag">Rehabilitation Equipment Guide</span>
              <h1>Best Physiotherapy Equipment & Rehab Equipment Manufacturer</h1>
              <p>
                Managing procurement for a rehabilitation department is rarely straightforward. Sourcing everything from one direct manufacturer simplifies your clinic's setup and ensures consistent clinical quality.
              </p>
              <div className="manu-btn-row">
                <a href="/contact" className="manu-btn manu-btn-primary">Get Factory Quote</a>
                <a href="/products" className="manu-btn manu-btn-outline">View Catalogue</a>
              </div>
            </div>
            <div className="manu-hero-image">
              <img src="https://primerehab.ascentbw.com/Image/Product/Pro6.png" alt="High Low Bobath Table by Prime Rehab Industries — leading physiotherapy and rehabilitation equipment manufacturer" />
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="manu-section">
        <div className="manu-container">
          <div className="manu-section-header">
            <h2>Streamline Your Procurement Headache</h2>
            <p style={{ maxWidth: '800px', margin: '0 auto' }}>
              Prime Rehab Industries manufactures over 100 physiotherapy and rehabilitation equipment models in-house, covering every major therapy specialty so your entire department can be sourced, installed, and supported through one point of contact.
            </p>
          </div>

          <div className="comparison-box">
            <div className="comp-card">
              <h3>Physiotherapy Equipment</h3>
              <p>Used during active treatment sessions: treatment tables, traction tables, tilt tables, and hands-on therapy tools. Designed for immediate therapeutic intervention.</p>
            </div>
            <div className="comp-card">
              <h3>Rehabilitation Equipment</h3>
              <p>Covers the broader recovery pathway: unweighing systems for gait training, Bobath tables for neuro-therapy, ADL training setups, and paediatric equipment.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="manu-section" style={{ backgroundColor: '#f8fafc' }}>
        <div className="manu-container">
          <div className="manu-section-header">
            <h2>Why a Single Manufacturer Matters</h2>
          </div>
          <div className="manu-benefit-grid">
            <div className="benefit-card">
              <h4>Quality Consistency</h4>
              <p>Standardised frame specifications, upholstery, and actuator ratings across every piece of equipment in your clinic.</p>
            </div>
            <div className="benefit-card">
              <h4>Centralised Support</h4>
              <p>Warranty and service are handled by one team, ensuring faster resolution if any piece needs clinical attention.</p>
            </div>
            <div className="benefit-card">
              <h4>Efficient Installation</h4>
              <p>Coordinated delivery and setup for your entire department, saving weeks of chasing separate vendors.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Specialties */}
      <section className="manu-section">
        <div className="manu-container">
          <div className="manu-section-header">
            <h2>100+ Models Across Every Specialty</h2>
            <p>12+ years of manufacturing experience refined into a comprehensive range.</p>
          </div>

          <div style={{ display: 'grid', gap: '40px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
              <div className="benefit-card">
                <h4 style={{ color: '#0284c7' }}>01. Outpatient Physiotherapy</h4>
                <p>Height-adjustable treatment tables like the High Low 3-Fold and Two Fold Table, designed for ergonomics and patient comfort.</p>
              </div>
              <div className="benefit-card">
                <h4 style={{ color: '#0284c7' }}>02. Neurological Recovery</h4>
                <p>Wide-surface High Low Bobath Tables and Unweighing Systems built for safe handling and neurodevelopmental therapy.</p>
              </div>
              <div className="benefit-card">
                <h4 style={{ color: '#0284c7' }}>03. Orthopaedic Care</h4>
                <p>Specialised traction tables and the SPINETHERA DTS Table for spinal decompression and intermittent traction protocols.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial 1 */}
      <section className="manu-quote-section">
        <div className="manu-container">
          <div className="manu-quote-box">
            <blockquote>"We sourced our entire outpatient physiotherapy setup from Prime Rehab — high-low tables, a tilt table, and a traction unit. The quality is consistently good across all product types, which is what you want when everything is from the same manufacturer."</blockquote>
            <cite>— Kavitha Nair, Head Physiotherapist, Madurai</cite>
          </div>
        </div>
      </section>

      {/* Technical Detail Section */}
      <section className="manu-section">
        <div className="manu-container">
          <div className="manu-section-header">
            <h2>What Sets Prime Rehab Equipment Apart</h2>
          </div>
          <div className="manu-benefit-grid">
            <div className="benefit-card">
              <h4>Precision Engineering</h4>
              <p>Built around heavy-gauge welded steel frames and high-cycle electric actuators rated for intensive daily clinic use.</p>
            </div>
            <div className="benefit-card">
              <h4>Therapist Ergonomics</h4>
              <p>Motorised height adjustments reduce musculoskeletal strain on practitioners working standing for extended periods.</p>
            </div>
            <div className="benefit-card">
              <h4>Clinical Versatility</h4>
              <p>From solo practices to large hospital wards, our equipment scales to fit any space and patient throughput requirement.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial 2 */}
      <section className="manu-quote-section">
        <div className="manu-container">
          <div className="manu-quote-box">
            <blockquote>"Working with Prime Rehab simplifies procurement significantly. For a centre like ours that handles outpatient physio alongside long-term rehab, having one manufacturer who makes both is a huge advantage."</blockquote>
            <cite>— Dr. Senthil Kumar, Medical Director, Tirunelveli</cite>
          </div>
        </div>
      </section>

      {/* Tips Section */}
      <section className="manu-section">
        <div className="manu-container">
          <div className="manu-section-header">
            <h2>How to Choose the Right Equipment</h2>
          </div>
          <div className="comparison-box">
            <div className="comp-card" style={{ borderLeft: '4px solid #f59e0b' }}>
              <h4>Match Your Protocols</h4>
              <p>Focus on what your therapists do daily. A spinal clinic needs a traction table; a neuro centre needs a Bobath table or unweighing system.</p>
            </div>
            <div className="comp-card" style={{ borderLeft: '4px solid #0284c7' }}>
              <h4>Plan for Growth</h4>
              <p>Think where your clinic will be in three years. Motorised models deliver the highest return as your patient volume increases.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="manu-section" style={{ backgroundColor: '#f8fafc' }}>
        <div className="manu-container">
          <div className="manu-section-header">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="manu-faq-list">
            <div className="manu-faq-item">
              <h5>What is the difference between physiotherapy and rehab equipment?</h5>
              <p>Physiotherapy equipment focuses on active hands-on treatment tools like treatment tables. Rehabilitation equipment supports the broader recovery pathway, including gait training and neurodevelopmental systems.</p>
            </div>
            <div className="manu-faq-item">
              <h5>Does Prime Rehab manufacture for both specialties?</h5>
              <p>Yes. We manufacture over 100 models across physiotherapy, chiropractic, orthopaedic, and neurological rehabilitation, all available from our Chennai facility.</p>
            </div>
            <div className="manu-faq-item">
              <h5>How do I choose the right treatment table?</h5>
              <p>It depends on your specialty. General physio benefits from motorised high-low tables; neuro centres need wide Bobath tables; spinal clinics need traction or tilt solutions.</p>
            </div>
            <div className="manu-faq-item">
              <h5>What are the lead times for delivery?</h5>
              <p>Standard models are typically ready faster than custom configurations. Lead times vary by order volume — contact our team for a specific estimate.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="manu-cta">
        <div className="manu-container">
          <h2>Source Your Entire Clinic Setup</h2>
          <p>Talk to our team about your clinic's equipment needs and get factory-direct pricing on the complete range of physiotherapy and rehabilitation equipment.</p>
          <div className="manu-btn-row">
            <a href="tel:+919994351947" className="manu-btn manu-btn-primary" style={{ backgroundColor: '#fff', color: '#0f172a' }}>Call: +91 99943 51947</a>
            <a href="/contact" className="manu-btn manu-btn-outline" style={{ borderColor: '#fff', color: '#fff' }}>Send Enquiry</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BestPhysioRehabManufacturer;
